import type { UseTranslationOptions } from 'react-i18next';
import { useTranslation } from 'react-i18next';

import type enLocales from './fenrir/en';
import i18n from './i18n';

type Prev = [never, 1, 2, 3, 4, 5];

// @internal TODO: Replace with `type-fest`'s `Paths` when it's available
type NestedKeyOf<T, Depth extends number = 5> = Depth extends 0
  ? never
  : {
      [K in Extract<keyof T, string>]: T[K] extends object
        ? K | `${K}.${NestedKeyOf<T[K], Prev[Depth]>}`
        : K;
    }[Extract<keyof T, string>];

export const useFenrirTranslation = (
  options: Omit<UseTranslationOptions<NestedKeyOf<typeof enLocales>>, 'i18n'>,
) =>
  useTranslation('fenrir', {
    ...options,
    i18n,
  });
